import { defineComponent as _defineComponent } from 'vue'
import { computed, provide, ref, useSlots, VNode } from 'vue'
    import { getDocumentAckMetadataPayload } from '../utils/document'
    import { useRouter } from 'vue-router/composables'
    import { DocumentSignatureType } from 'aven_types'
    import store from '../store'
    import { logEvent } from '../utils/http-client'
    import { log } from '../utils/logger'
    import { AdditionalAcknowledgementsPosition } from '../utils/legal.types'

    
export default /*#__PURE__*/_defineComponent({
  __name: 'AckTermsButton',
  props: {
    docs: null,
    disabled: { type: Boolean },
    dataTestid: null,
    submitting: { type: Boolean },
    buttonClasses: null,
    eventName: null,
    additionalAcknowledgementsPosition: null
  },
  emits: ["click", "error"],
  setup(__props: any, { emit }: { emit: ({
            (e: 'click'): void
            (e: 'error', error: string): void
        }), expose: any, slots: any, attrs: any }) {

const props = __props as {
            docs: {
                docType: string
                signature: string
                signatureType: DocumentSignatureType
            }[]
            disabled?: boolean
            dataTestid?: string
            submitting?: boolean
            buttonClasses?: string
            eventName?: string
            additionalAcknowledgementsPosition?: AdditionalAcknowledgementsPosition
        }

    

    

    const slots = useSlots()
    const router = useRouter()

    const ackSubmitting = ref(false)
    const errorText = ref('')
    const additionalAckRef = ref<HTMLDivElement | undefined>(undefined)

    const getTextFromVNode = (nodes: VNode[]): string => {
        return nodes
            .map((node: VNode) => {
                return node.text ? node.text : getTextFromVNode(node.children ?? [])
            })
            .join('')
            .trim()
    }

    const ctaText = computed(() => {
        const ctaSlot = slots.cta?.()
        if (ctaSlot) {
            return getTextFromVNode(ctaSlot)
        }
        log.warn('No cta text found for AckTermsButton')
        return ''
    })
    provide('ctaText', ctaText)

    const handleClick = async (evt: Event) => {
        const docAckMetadata = getDocumentAckMetadataPayload(evt, router.currentRoute.fullPath)

        if (props.eventName) {
            logEvent(props.eventName, docAckMetadata)
        }

        ackSubmitting.value = true

        let additionalAckText = undefined
        if (additionalAckRef.value) {
            additionalAckText = additionalAckRef.value.textContent
        }

        await Promise.all(
            props.docs.map(async (doc) => {
                // get ack metadata
                const ackMetadata = {
                    ...docAckMetadata,
                    signature: doc.signature,
                    signatureType: doc.signatureType,
                }

                const { success, error } = await store.dispatch('ackDocument', { docType: doc.docType, ackMetadata, additionalAcknowledgements: additionalAckText })
                if (!success) {
                    errorText.value = error
                    emit('error', error)
                }
            })
        )

        emit('click')
        ackSubmitting.value = false
    }

return { __sfc: true,emit, props, slots, router, ackSubmitting, errorText, additionalAckRef, getTextFromVNode, ctaText, handleClick }
}

})